var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "dashboard-thread-list-item",
      attrs: {
        href: "#drawer-messages-chat",
        "data-toggle": "drawer",
        "aria-foldedopen": "false",
        "aria-controls": "drawer-messages-chat",
      },
      on: { click: _vm.handleGetThreadCallback },
    },
    [
      _c("a", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-1 participants-container" },
            _vm._l(_vm.participantsAvatars, function (p, index) {
              return _c("img", {
                key: p.id,
                style: {
                  left: index * 15 + "px",
                  "z-index": _vm.participantsAvatars.length - index,
                },
                attrs: { src: p.avatar },
              })
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-sm-10 col-md-6" }, [
            _c("h3", { staticClass: "chat-lead" }, [
              _vm._v("\n          " + _vm._s(_vm.booking.name) + "\n        "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chat-sub participants" }, [
              _vm._v(_vm._s(_vm.participantsNames)),
            ]),
            _vm._v(" "),
            _vm.thread.latest_message
              ? _c("span", [
                  _c(
                    "span",
                    {
                      class: this.thread.unread_count
                        ? "unread-messages"
                        : "chat-sub message-text",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.messageName) +
                          ": " +
                          _vm._s(
                            _vm.thread.latest_message.type === "file"
                              ? "File Uploaded"
                              : _vm.thread.latest_message.text
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "pull-right",
                      class: this.thread.unread_count
                        ? "unread-messages"
                        : "chat-sub message-text",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.messageTimestamp) +
                          "\n            "
                      ),
                      this.thread.unread_count && !_vm.$userIsAdmin
                        ? _c(
                            "span",
                            { staticClass: "unread-circle pull-right" },
                            [_vm._v("\n               \n            ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.thread.unread_count && _vm.$userIsAdmin
                        ? _c("span", { staticClass: "pull-right" }, [
                            _vm._v(
                              "\n               | " +
                                _vm._s(this.thread.unread_count) +
                                " unread\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ])
              : _c("span", [
                  _c("span", { staticClass: "chat-sub message-text" }, [
                    _vm._v("No Messages"),
                  ]),
                ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "hidden-xs hidden-sm col-md-4 details-panel" },
            [
              _c("p", [
                _vm.bookingIsContextuallyCancelled
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Cancelled"),
                    ])
                  : _vm.bookingIsScheduled
                  ? _c("span", { staticClass: "label label-success" }, [
                      _vm._v("Scheduled"),
                    ])
                  : _vm.bookingIsOnHold
                  ? _c("span", { staticClass: "label label-info" }, [
                      _vm._v("On Hold"),
                    ])
                  : _vm.bookingIsBooked
                  ? _c("span", { staticClass: "label label-success" }, [
                      _vm._v("Booked"),
                    ])
                  : _vm.bookingIsCompleted
                  ? _c("span", { staticClass: "label label-success" }, [
                      _vm._v("Completed"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin && _vm.bookingIsNotPublic
                  ? _c("span", { staticClass: "label-hidden" }, [
                      _vm._v("Hidden"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$paymentsModuleEnabled && _vm.bookingBookedDepositUnpaid
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Deposit Unpaid"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$paymentsModuleEnabled && _vm.bookingBookedDepositSent
                  ? _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Deposit Sent"),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm.$userIsTalent || _vm.$userIsManager
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("nullable")(
                              _vm._f("currency")(
                                _vm.booking.budget_per_star_as_user_rate,
                                _vm.booking.currency
                              )
                            )
                          ) +
                          "\n            "
                      ),
                      _vm.$userIsManager
                        ? _c("span", [
                            _vm._v(
                              "\n              /" +
                                _vm._s(_vm.$starLabel) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.booking.budget_per_star,
                              _vm.booking.currency
                            )
                          ) +
                          "\n            "
                      ),
                      _vm.$userIsAdmin
                        ? _c("span", [
                            _vm._v(
                              "\n              (" +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.booking.budget_per_star_as_user_rate,
                                    _vm.booking.currency
                                  )
                                ) +
                                ")\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n            /" +
                          _vm._s(_vm.$starLabel) +
                          "\n          "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _vm.$userIsAdmin && _vm.$paymentsModuleEnabled
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-6" }, [
                      _vm.bookingAppearanceInPerson
                        ? _c("p", [
                            _c("i", { staticClass: "fa fa-calendar fa-fw" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("nullable")(
                                    _vm._f("dateTimezone")(
                                      _vm.booking.tz_date,
                                      _vm.booking.timezone,
                                      _vm.$user.date_format_preference
                                    )
                                  )
                                )
                            ),
                          ])
                        : _c("p", [
                            _c("i", { staticClass: "fa fa-calendar fa-fw" }),
                            _vm._v(" –"),
                          ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("i", { staticClass: "fa fa-globe fa-fw" }),
                        _vm._v(" " + _vm._s(_vm.bookingStateOrOnline)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6" }, [
                      _vm.$userIsAdmin
                        ? _c("p", [
                            _vm._v("Booking ID: " + _vm._s(_vm.booking.id)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.booking.payments && _vm.booking.payments.length > 0
                        ? _c(
                            "p",
                            _vm._l(_vm.booking.payments, function (payment) {
                              return _c(
                                "span",
                                {
                                  key: payment.id,
                                  staticStyle: {
                                    "text-transform": "capitalize",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(payment.type) +
                                      ": " +
                                      _vm._s(payment.status) +
                                      ","
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }